/** Qo'ng'iroq oynasi (driver mahalliy soati) va ro'yxat uzunligi */
import { useTranslation } from "react-i18next";
import type { Me } from "@/features/auth/types";
import { Select } from "@/components/ui/field";
import type { WidgetItem } from "../types";
import { LIMITS, type CallNowConfig } from "./config";

type Props = { item: WidgetItem<CallNowConfig>; me: Me; onChange: (config: CallNowConfig) => void };

const HOURS = Array.from({ length: 25 }, (_, h) => h);
const hh = (h: number) => `${String(h % 24).padStart(2, "0")}:00`;

export function CallNowSettings({ item, onChange }: Props) {
  const { t } = useTranslation("widgets");
  const c = item.config;
  const [from, to] = c.call;
  return (
    <div className="space-y-4">
      <section>
        <div className="mb-1.5 text-[12px] font-semibold">{t("clock.callHours")}</div>
        <div className="grid grid-cols-2 gap-2">
          <label className="text-[12px] text-muted">
            {t("clock.callFrom")}
            <Select value={String(from)} onChange={(e) => onChange({ ...c, call: [Number(e.target.value), Math.max(to, Number(e.target.value) + 1)] })} className="mt-1">
              {HOURS.slice(0, 24).map((h) => (
                <option key={h} value={h}>
                  {hh(h)}
                </option>
              ))}
            </Select>
          </label>
          <label className="text-[12px] text-muted">
            {t("clock.callTo")}
            <Select value={String(to)} onChange={(e) => onChange({ ...c, call: [Math.min(from, Number(e.target.value) - 1), Number(e.target.value)] })} className="mt-1">
              {HOURS.slice(1).map((h) => (
                <option key={h} value={h}>
                  {hh(h)}
                </option>
              ))}
            </Select>
          </label>
        </div>
        <p className="mt-1 text-[11px] text-muted">{t("callnow.callHint")}</p>
      </section>
      <section>
        <div className="mb-1.5 text-[12px] font-semibold">{t("callnow.limit")}</div>
        <Select value={String(c.limit)} onChange={(e) => onChange({ ...c, limit: Number(e.target.value) as CallNowConfig["limit"] })}>
          {LIMITS.map((n) => (
            <option key={n} value={n}>
              {n}
            </option>
          ))}
        </Select>
      </section>
    </div>
  );
}
